import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel, ConsultaSeguimentoOutroFieldModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum {
  FALA = 'FALA',
  EMITE_SOM_OU_BARULHO = 'EMITE_SOM_OU_BARULHO',
  OLHA_PARA = 'OLHA_PARA',
  CONTINUA_OLHANDO = 'CONTINUA_OLHANDO',
}

export interface ConsultaSeguimentoPergunta17Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_17_HEADER?: SimNaoEnum
  PERGUNTA_17_TENTA_FAZER_QUE_OLHE?: Record<ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum, SimNaoEnum>
  OUTRO?: ConsultaSeguimentoOutroFieldModel
}
